<template>
  <div class="text-center main_app_loading" v-if="isLoading">
    <b-spinner label="Loading..."></b-spinner>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AppLoading",
  computed: {
    ...mapGetters({
      isLoading: ["globalData/getLoading"],
    }),
  },
};
</script>

<style lang="scss" scoped>
.main_app_loading {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 7777;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
